import { render } from "./magnifier.svg?vue&type=template&id=564e49cc?inline"
const script = {}
script.render = render

export default script